import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ApiResponse, Entity } from '@cervotech/types/api';
import { Observable } from 'rxjs';
import { normalizeUrl, toUrlQueryString } from '../utils';

export const API_BASE_URL = new InjectionToken<any>('API_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class ApiService<T> {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {}

  getOne<P = T>(
    id: Entity['id'],
    endPoint: string,
    query: string = ''
  ): Observable<ApiResponse<P>> {
    const baseUrl = normalizeUrl(`${this.baseUrl}/${endPoint}`);
    return this.http.get(`${baseUrl}/${id}?${query}`);
  }

  deleteOne(
    id: Entity['id'],
    endPoint: string
  ): Observable<ApiResponse<boolean>> {
    const baseUrl = normalizeUrl(`${this.baseUrl}/${endPoint}`);
    return this.http.delete(`${baseUrl}/${id}`);
  }

  get<P = T>(
    endPoint: string,
    query: string = ''
  ): Observable<ApiResponse<P[]>> {
    const baseUrl = normalizeUrl(`${this.baseUrl}/${endPoint}`);
    return this.http.get(baseUrl + '?' + query);
  }

  save(entity: Entity, endPoint: string): Observable<ApiResponse<T>> {
    const baseUrl = normalizeUrl(`${this.baseUrl}/${endPoint}`);
    if (entity.id && entity.id !== 'new') {
      return this.http.patch(`${baseUrl}/${entity.id}`, entity);
    }
    return this.http.post(baseUrl, entity);
  }

  execute<P, T = any>(
    endPoint: string,
    method: 'POST' | 'GET' | 'PATCH' | 'DELETE' = 'GET',
    body?: T
  ): Observable<ApiResponse<P>> {
    const baseUrl = normalizeUrl(`${this.baseUrl}/${endPoint}`);
    switch (method) {
      case 'POST':
        return this.http.post(baseUrl, body);
      case 'PATCH':
        return this.http.patch(baseUrl, body);
      case 'GET':
        return this.http.get(`${baseUrl}?${toUrlQueryString(body)}`);
      case 'DELETE':
        return this.http.delete(`${baseUrl}?${toUrlQueryString(body)}`);
    }
  }
}
